import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { positionDropdown } from '../../../../common/dropdown'
import { Element } from '../../../../common/html/element'
import { Table } from '../../../../common/table'
import { Tooltip } from '../../../../common/tooltip'
import { DATA_TABLE } from './constant'
import { selectCellData, selectIds } from './store/slice'

export const BusinessSizeTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectIds)

  return (
    <Table
      ids={ids}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectCellData}
      schema={Object.values(DATA_TABLE).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          thStyle: item.thStyle,
          render: (val, { locale, rowId, colId }) => {
            switch (item.key) {
              case DATA_TABLE.numberCompanies.key:
              case DATA_TABLE.totalPercentCompanies.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              default:
                return (
                  <CellTooltip
                    data={item.format(val)}
                    rowId={rowId}
                    colId={colId}
                  />
                )
            }
          },
        }
      })}
    />
  )
}

BusinessSizeTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}

const CellTooltip = ({ data, rowId, colId }) => {
  const dataCell = useSelector(selectCellData(rowId, 'companySizeDescription'))
  if (dataCell) {
    return (
      <Tooltip
        tooltipContent={dataCell}
        position={positionDropdown.TOP_START_RIGHT}
      >
        <Element>{data}</Element>
      </Tooltip>
    )
  }
  return <Element>{data}</Element>
}
